import React, { useState, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import {
  getTicketActionModal,
  postTicketRefund,
} from '../../../../../actions/index';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import {
  generateTicketRefund,
  TICKET_REFUND_MODAL_ENDPOINT,
} from '../../../../../config/endpoints';
import { POST } from '../../../../../config/permissions';
import ConfirmationModal from '../../../../common/modal/ConfirmationModal';
import { MODAL_ACTION_CONFIRM_MESSAGE } from '../../../../../config/messages';
import RefundForm from './RefundForm';
import Modal from '../../../../common/modal/Modal';

const RefundButton = ({
  ticketId,
  ticketSalePrice,
  status,
  dispatchGetTicketActionModal,
  dispatchPostTicketRefund,
  forThirdParty,
  disabled
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showRefundFormModal, setRefundFormModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(MODAL_ACTION_CONFIRM_MESSAGE);
  const [url, setUrl] = useState(null);

  const handleTicketRefund = (formValues) => {
    const {
      expenseTypeId,
      costCenterId,
      authorizerUserId,
      description,
      salePrice,
      creditNoteMotive,
      creditNoteMotiveDescription,
    } = formValues;
    const refundPayload = {
      expenseTypeId: expenseTypeId.value,
      costCenterId: costCenterId.value,
      userId: authorizerUserId.value,
      description,
      salePrice,
      creditNoteMotive: creditNoteMotive ? creditNoteMotive.value : null,
      creditNoteMotiveDescription,
    };
    dispatchPostTicketRefund(url, ticketId, forThirdParty, refundPayload);
  };

  const handleShowModal = async () => {
    setLoading(true);

    const response = await dispatchGetTicketActionModal({
      ticketId,
      url: TICKET_REFUND_MODAL_ENDPOINT,
    });

    if (response && response.message && response.url) {
      setMessage(response.message);
      setUrl(response.url.replace('/ticket/{ticketId}', ''));
      setShowConfirmationModal(true);
    }

    setLoading(false);
  };

  const handleCloseModal = () => {
    setRefundFormModal(false);
    setShowConfirmationModal(false);
  };

  const handleConfirmRefund = () => {
    setShowConfirmationModal(false);
    setRefundFormModal(true);
  };

  return (
    <>
      <Button color="warning" onClick={handleShowModal} disabled={disabled}>
        <i className={`fa fa-${loading ? 'spinner fa-spin' : 'usd'}`} />{' '}
        Devolución
      </Button>
      <ConfirmationModal
        show={showConfirmationModal}
        title="Confirmación de Devolución"
        body={message}
        onClickConfirm={handleConfirmRefund}
        onClickCancel={handleCloseModal}
        cancelButtonColor="warning"
      />
      <Modal
        show={showRefundFormModal}
        title="Formulario para Devolución"
        body={
          <RefundForm
            ticketId={ticketId}
            status={status}
            initialValues={{ salePrice: ticketSalePrice }}
            onSubmit={handleTicketRefund}
            onCancel={handleCloseModal}
          />
        }
        size="md"
      />
    </>
  );
};

RefundButton.propTypes = {
  dispatchGetTicketActionModal: PropTypes.func.isRequired,
  dispatchPostTicketRefund: PropTypes.func.isRequired,
  ticketId: PropTypes.number.isRequired,
  ticketSalePrice: PropTypes.number.isRequired,
  forThirdParty: PropTypes.bool,
  status: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
RefundButton.defaultProps = {
  forThirdParty: false,
  disabled: false
};

const mapDispatchToProps = {
  dispatchGetTicketActionModal: getTicketActionModal,
  dispatchPostTicketRefund: postTicketRefund,
};

const connectedComponent = connect(null, mapDispatchToProps)(RefundButton);

export default withEndpointAuthorization({
  url: generateTicketRefund(0),
  permissionType: POST,
})(connectedComponent);
